"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequest$ = exports.GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequest$outboundSchema = exports.GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequest$inboundSchema = exports.GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurity$ = exports.GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurity$outboundSchema = exports.GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurity$inboundSchema = void 0;
exports.getOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurityToJSON = getOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurityToJSON;
exports.getOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurityFromJSON = getOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurityFromJSON;
exports.getOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequestToJSON = getOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequestToJSON;
exports.getOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequestFromJSON = getOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurity$;
(function (GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurity$) {
    /** @deprecated use `GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurity$inboundSchema` instead. */
    GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurity$.inboundSchema = exports.GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurity$inboundSchema;
    /** @deprecated use `GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurity$outboundSchema` instead. */
    GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurity$.outboundSchema = exports.GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurity$outboundSchema;
})(GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurity$ || (exports.GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurity$ = GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurity$ = {}));
function getOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurityToJSON(getOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurity) {
    return JSON.stringify(exports.GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurity$outboundSchema
        .parse(getOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurity));
}
function getOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetSecurity' from JSON`);
}
/** @internal */
exports.GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequest$inboundSchema = z.object({
    outcode: z.string(),
});
/** @internal */
exports.GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequest$outboundSchema = z.object({
    outcode: z.string(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequest$;
(function (GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequest$) {
    /** @deprecated use `GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequest$inboundSchema` instead. */
    GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequest$.inboundSchema = exports.GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequest$inboundSchema;
    /** @deprecated use `GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequest$outboundSchema` instead. */
    GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequest$.outboundSchema = exports.GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequest$outboundSchema;
})(GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequest$ || (exports.GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequest$ = GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequest$ = {}));
function getOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequestToJSON(getOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequest) {
    return JSON.stringify(exports.GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequest$outboundSchema
        .parse(getOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequest));
}
function getOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequest$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGetRequest' from JSON`);
}
//# sourceMappingURL=getoutcodepostcodelocationoutcodesoutcodepostcodelocationget.js.map